import { typeCreatorV2 } from 'redux/utils/common';

export const SET_TASK_DETAIL: string = typeCreatorV2(
  'ViewTaskReducer',
  'SetTaskDetail'
);

export const COMMENT_TASK: string = typeCreatorV2(
  'ViewTaskReducer',
  'CommentTask'
);
export const SET_COMMENT_TASK: string = typeCreatorV2(
  'ViewTaskReducer',
  'SetCommentTask'
);

export const UPLOAD_FILE_COMMENT: string = typeCreatorV2(
  'ViewTaskReducer',
  'UploadFileComment'
);
export const LIKE_TASK: string = typeCreatorV2('ViewTaskReducer', 'LikeTask');
